<template>
    <div class="">
        <div class="container lnb d_container">
            <div class="contents_wrap no_height">
                <div class="contents list-container" v-show="memberType != 0">
                    <div class="title">{{ nickName }} 상세정보</div>
                    <div class="write_tab">
            <div class="write_tab_content tab_member_detail" @click="movePage(`/member/detail/${memberKey}`)"
                 :class="{tab_no_curator: !IsCurator}">
              기본정보
            </div>
            <div class="write_tab_content tab_member_detail active" @click="movePage(`/member/mingle/${memberKey}`)"
                 :class="{tab_no_curator: !IsCurator}">
              밍글 사용내역
            </div>
            <div class="write_tab_content tab_member_detail" v-if="checkIsNotMemberTypeManager(memberType)" @click="movePage(`/member/portfolio/${memberKey}`)"
                 :class="{tab_no_curator: !IsCurator}">
              포트폴리오
            </div>
            <div class="write_tab_content tab_member_detail" v-if="checkIsNotMemberTypeManager(memberType)" @click="movePage(`/member/collect/${memberKey}`)"
                 :class="{tab_no_curator: !IsCurator}">
              컬렉션
            </div>
            <div class="write_tab_content tab_member_detail" v-if="checkIsNotMemberTypeManager(memberType)" @click="movePage(`/member/collection/${memberKey}`)"
                 :class="{tab_no_curator: !IsCurator}">
              갤러리
            </div>
            <div class="write_tab_content tab_member_detail" v-if="checkIsNotMemberTypeDirector(memberType) && checkIsNotMemberTypeManager(memberType)" @click="movePage(`/member/item/${memberKey}`)"
                 :class="{tab_no_curator: !IsCurator}">
              아이템
            </div>
            <div class="write_tab_content tab_member_detail" @click="movePage(`/member/utility/${memberKey}`)"
                 :class="{tab_no_curator: !IsCurator}">
              유틸리티
            </div>
            <div class="write_tab_content tab_member_detail" v-if="checkIsNotMemberTypeDirector(memberType) && checkIsNotMemberTypeManager(memberType)" @click="movePage(`/member/competition/${memberKey}`)"
                 :class="{tab_no_curator: !IsCurator}">
              공모전
            </div>
            <div v-show="IsCurator" class="write_tab_content tab_member_detail" v-if="checkIsNotMemberTypeDirector(memberType)"
                 @click="movePage(`/member/curator/${memberKey}`)" :class="{tab_no_curator: !IsCurator}">
              큐레이션
            </div>
          </div>
                    <div>
                        <member-write-component :memberType="`setNick`" :memberKey="memberKey" :setNickName="setNickName"></member-write-component>
                        <!--          <history-list-component :history-type="`history`"></history-list-component>-->
                        <point-list-component :pointType="`pointHistory`" :memberKey="memberKey"></point-list-component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MemberWriteComponent from "@/components/member/MemberWriteComponent";
import PointListComponent from "@/components/point/PointListComponent";
import PortfolioListComponent from "@/components/portfolio/PortfolioListComponent";
import CollectionListComponent from "@/components/collection/CollectionListComponent";
import ItemListComponent from "@/components/item/ItemListComponent";
import CompetitionListComponent from "@/components/competition/CompetitionListComponent";
import CurationListComponent from "@/components/curation/CurationListComponent";
import {mapState} from "vuex";
import EventBus from "@/utils/event-bus";

export default {
    name: "MemberMingle",
    mixins: [],
    components: {
        MemberWriteComponent,
        PointListComponent,
        PortfolioListComponent,
        CollectionListComponent,
        ItemListComponent,
        CompetitionListComponent,
        CurationListComponent
    },
    inject: [],
    provide() {
        return{
        }
    },
    props: {
    },
    data() {
        return{
            memberKey: Number(this.$route.params.mb_no),
            nickName: '',
            memberType : 0,
        }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {
        this.$store.dispatch('memberDetail/setIsCurator', {mb_no: this.memberKey})
        EventBus.$on('setMemberType', (data)=> {
        this.memberType = data
    })
    },
    beforeDestroy() {
        this.$store.dispatch('memberDetail/setIsCurator',{mb_no :this.memberKey})
    },
    destroyed() {},
    computed: {
        ...mapState({
            IsCurator: state => state.memberDetail.IsCurator,
        })

    },
    methods:{
        movePage(url){
            this.$router.push(url)
        },
        setNickName(nick) {
            this.nickName = nick;
        },
        checkIsNotMemberTypeDirector(memberType){
      if(memberType == 7){
        return false
      }
      return true
    },
    checkIsNotMemberTypeManager(memberType){
      if(memberType == 8){
        return false
      }
      return true
    }
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
